import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { UsersEntity } from '@app.raytd.com/store';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

import React from 'react';
import { cn, getOrganisationName } from '@/lib/utils';


interface AuthorBadgeProps {
    item: UsersEntity;
    size?: 'small' | 'medium' | 'large' | 'normal' | 'medium-small';
}

const sizeClasses = {
    small: {
        org: 'h-6 w-6',
        user: 'h-6 w-6',
        container: '-space-x-1'
    },
    'medium-small': {
        org: 'h-8 w-8',
        user: 'h-6 w-6',
        container: '-space-x-2'
    },
    medium: {
        org: 'h-8 w-8',
        user: 'h-8 w-8',
        container: '-space-x-3'
    },
    normal: {
        org: 'h-12 w-12',
        user: 'h-10 w-10',
        container: '-space-x-3'
    },
    large: {
        org: 'h-24 w-24',
        user: 'h-14 w-14',
        container: '-space-x-4',
    }
};

const AuthorBadge = React.memo(({ item, size = 'medium' }: AuthorBadgeProps) => {
    if (!item) {
        return null;
    }

    console.info('item', item);


    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <div className={cn("flex flex-row items-end", sizeClasses[size].container)}>
                        <Avatar className={cn("border border-white", sizeClasses[size].org)}>
                            <AvatarImage
                                src={'logo_url' in (item?.company || {}) ? item?.company?.logo_url : undefined}
                                alt={getOrganisationName(item?.company)}
                                sizes=''
                                className='object-cover'
                            />
                            <AvatarFallback>{getOrganisationName(item?.company)?.[0]}</AvatarFallback>
                        </Avatar>
                        <Avatar className={cn("border border-white", sizeClasses[size].user)}>
                            <AvatarImage
                                src={item?.avatar}
                                alt={item?.name}
                                sizes=''
                                className='object-cover'
                            />
                            <AvatarFallback>
                                {item?.name
                                    ?.split(' ')
                                    .map(word => word[0])
                                    .slice(0, 2)
                                    .join('')
                                    .toUpperCase()}
                            </AvatarFallback>
                        </Avatar>
                    </div>
                </TooltipTrigger>
                <TooltipContent>
                    <p>{item?.name} @ {getOrganisationName(item?.company)}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    )
});

export default AuthorBadge;